module.exports = __webpack_public_path__ + "static/1-a59cd6e85c49f9a7b203e1e6ce8a1812.jpg";